import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Link from '../Link';
import UppercaseHeader from '../UppercaseHeader';

import 'css/components/www/_LandingDropdown.scss';

export default class LandingDropdown extends Component {
  static propTypes = {
    options: PropTypes.array,
    trigger: PropTypes.string,
  };

  state = {
    dropdownOpen: false,
  };

  onLinkTapped = () => {
    this.setState({
      dropdownOpen: false,
    });
  };

  onMouseLeave = () => {
    this.setState({
      dropdownOpen: false,
    });
  };

  onMouseOver = () => {
    this.setState({
      dropdownOpen: true,
    });
  };

  renderDropdown() {
    const { options } = this.props;
    const { dropdownOpen } = this.state;

    var className = 'dropdown';

    if (dropdownOpen) {
      className += ' open';
    }

    const items = [];
    options.forEach((option, i) => {
      if (option.type === 'heading') {
        items.push(
          <div className="heading" key={option.name}>
            {option.name}
          </div>
        );
      } else if (option.type === 'linkHeading') {
        items.push(
          <Link className="linkHeading" key={option.name} onTap={this.onLinkTapped} to={option.to}>
            {option.name}
          </Link>
        );
      } else if (option.type === 'externalLinkHeading') {
        items.push(
          <a
            className="linkHeading"
            key={option.name}
            href={option.to}
            rel="noopener"
            target="_blank">
            {option.name}
          </a>
        );
      } else if (option.type === 'external') {
        items.push(
          <a className="option" key={option.name} href={option.to} rel="noopener" target="_blank">
            {option.name}
          </a>
        );
      } else if (option.type === 'soloOption') {
        items.push(
          <Link className="option solo" key={option.name} onTap={this.onLinkTapped} to={option.to}>
            {option.name}
          </Link>
        );
      } else {
        items.push(
          <Link className="option" key={option.name} onTap={this.onLinkTapped} to={option.to}>
            {option.name}
          </Link>
        );
      }
    });

    return <div className={className}>{items}</div>;
  }

  render() {
    return (
      <div
        className="link landingDropdown"
        onMouseOver={this.onMouseOver}
        onMouseLeave={this.onMouseLeave}
        onTouchEnd={this.onTouchEnd}>
        <UppercaseHeader>{this.props.trigger}</UppercaseHeader>
        <div className="icon-chevron-down" />
        {this.renderDropdown()}
      </div>
    );
  }
}
